var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 24,
  viewBox: "-583 1484 32 34"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M-559.5 1513.8h-2.1v-17h-4.3v17h-2.1v-17h-4.3v17h-2.2v-17h-4.2v20.2c0 .6.5 1.1 1.1 1.1h21.3c.6 0 1.1-.5 1.1-1.1v-20.2h-4.3v17zM-553.1 1488.3h-8.5v-3.2c0-.6-.5-1.1-1.1-1.1h-8.5c-.6 0-1.1.5-1.1 1.1v3.2h-8.6c-1.1 0-2.1.9-2.1 2.1v2.1c0 1.2 1 2.1 2.1 2.1h27.7c1.2 0 2.1-1 2.1-2.1v-2.1c.1-1.2-.9-2.1-2-2.1zm-10.7 0h-6.4v-2.2h6.4v2.2z"
})));
export default SvgIconTrash;